import * as z from "zod/v4";

export const MonthlyDeliverabilityMetrics = z.object({
  month: z.date(),
  openRate: z.number(),
  clickRate: z.number(),
  bounceRate: z.number(),
  spamRate: z.number(),
  unsubscribeRate: z.number(),
});

export interface MonthlyDeliverabilityMetrics
  extends z.infer<typeof MonthlyDeliverabilityMetrics> {}
